var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('ul',{staticClass:"menu"},[_c('li',{on:{"click":_vm.menu1}},[_vm._v("员工管理")]),_c('li',{on:{"click":_vm.menu2}},[_vm._v("新增员工")])])])}
var staticRenderFns = []

export { render, staticRenderFns }